import React, { useContext, useEffect, useState } from 'react';
import { ProfileHeaderWrapper } from "./style";
import editIcon from "../../../images/edit.svg";
import { useNavigate, Link } from "react-router-dom";
import ContextDashboard from '../../../Context/ContextDashboard';
import { getDashboardData } from '../../../Utils/api';
import { getStorage, isEmpty } from '../../../Utils/common';
import {
  Home,
  User,
  CreditCard,
  Wallet,
  Settings,
  ShieldCheck,
  Mail,
  BadgeInfo,
} from "lucide-react";

function ProfileHeader({ children }) {
  const { message, setMessage, setProfileData, outdata, profileData, setSetps, getProfileDaital } = useContext(ContextDashboard);
  const [dashboard, setDashboard] = useState([]);
  const navigate = useNavigate();

  // Fetch dashboard data on component mount
  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setDashboard(dashboardData);
      }
    });
  }, []);

  // Redirect to upload picture page
  const redirect = (link) => {
    navigate("/my-dashboard/upload-picture");
  };

  // Handle UPI payment on Pay Now click
  const handlePayNow = () => {
    const upiId = "nishtha1234qr@fbl"; 

const upiLink = `upi://pay?pa=${upiId}&pn=KMUser&am=${dashboard?.Data?.active_loan_details?.total_due}&cu=INR`;
    window.location.href = upiLink;
  };

  // Check if active_loan_details has valid data
  const hasActiveLoanDetails = dashboard?.Data?.active_loan_details &&
    (dashboard?.Data?.active_loan_details?.total_due > 0 ||
      Object.keys(dashboard?.Data?.active_loan_details).length > 0);

  return (
    <ProfileHeaderWrapper>
      <div className=' main w-full flex flex-col'>
        <div className=" flex flex-col sm:flex-row justify-center">
          <div className="imgBox border p-1 border-gray-200 shadow-md">
            <img src={dashboard?.Data?.profile_pic} alt="" />
            {/* <div className="editIcon center" onClick={redirect}>
          <img src={editIcon} alt="" />
        </div> */}
          </div>

          <div className="textBox  mt-4 sm:ml-14">
            {/* Conditionally render Outstanding Amount and Pay Now button */}
            {hasActiveLoanDetails ? (
              <div className="outstandingAmount">
                <h2>
                  Outstanding Amount: {dashboard?.Data?.active_loan_details?.total_due || ""}
                </h2>
                <button style={{ float: "right", marginTop: "10px" }} onClick={handlePayNow}>Pay Now</button>
              </div>
            ) : null}




            {/* <div className='flex flex-col  justify-start gap-4'>
              <div className="flex  flex-wrap  justify-start items-center ">
                <div className='flex gap-3 items-center'>
                  <div className=" w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center xs:w-[6] xs:h-[6]  ">
                    <User className="text-blue-600" size={20} />
                  </div>
                  <span className="title ">Name:</span>
                </div>
                <span className="value  ">{dashboard?.Data?.full_name || "NA"}</span>
              </div>

              <div className="flex  justify-start items-center ">
                <div className='flex gap-3 items-center'>
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <CreditCard size={18} className="text-blue-600" />
                  </div>
                  <span className="title ">PAN Card:</span>
                </div>
                <span className="value ">{dashboard?.Data?.profile_details?.pancard || "NA"}</span>
              </div>

              <div className="flex  justify-start items-center ">
                <div className='flex gap-3 items-center'>
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <Mail size={18} className="text-blue-600" />
                  </div>
                  <span className="title ">Email:</span>
                </div>
                <span className="value "> {dashboard?.Data?.profile_details?.personal_email?.trim()
                  ? dashboard?.Data?.profile_details?.personal_email.toLowerCase()
                  : "NA"}</span>
              </div>
            </div> */}

            <div className="flex flex-col gap-5">

              {/* Name */}
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <User className="text-blue-600" size={20} />
                </div>

                <div className="flex flex-1 justify-between items-center gap-4">
                  <span className="text-gray-700 font-medium min-w-[90px]">
                    Name:
                  </span>

                  <div className="flex-1 text-left">
                    <span className="font-bold text-[#173A7A] ">
                      {dashboard?.Data?.full_name || "NA"}
                    </span>
                  </div>
                </div>
              </div>

              {/* PAN */}
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <CreditCard className="text-blue-600" size={18} />
                </div>

                <div className="flex flex-1 justify-between items-center gap-4">
                  <span className="text-gray-700 font-medium min-w-[90px]">
                    PAN Card:
                  </span>
                  <div className="flex-1 text-left">
                    <span className="font-bold text-[#173A7A] text-right break-words">
                      {dashboard?.Data?.profile_details?.pancard || "NA"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <Mail className="text-blue-600" size={18} />
                </div>

                <div className="flex flex-1 justify-between items-center gap-4">
                  <span className="text-gray-700 font-medium min-w-[90px]">
                    Email:
                  </span>
                  <div className="flex-1 text-left">
                    <span className="font-bold text-[#173A7A] text-left break-all max-w-[220px] sm:max-w-full">
                      {dashboard?.Data?.profile_details?.personal_email?.trim()
                        ? dashboard?.Data?.profile_details?.personal_email.toLowerCase()
                        : "NA"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full items-center rounded-xl bottom ">
          <p>
            Don't let uncertainty hold you back. It's time to explore the
            possibilities.
          </p>
          {children}

        </div>




      </div>
    </ProfileHeaderWrapper >
  );
}

export default ProfileHeader;